import React from 'react';

type OnChangeFunction<T> = (data?: T) => void;

export function useSafeCallback<T>(onChange?: OnChangeFunction<T>): (data?: T) => void {
  const onChangeRef = React.useRef(onChange);

  React.useLayoutEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  const safeOnChange = React.useCallback((data?: T) => {
    if (onChangeRef.current) {
      onChangeRef.current(data);
    }
  }, []);

  return safeOnChange;
}
